import ContentProviderEndpoint from '../../Content/ContentProviderEndpoint';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FundVideo } from '../../Kentico/DigitalDesign/fund_video';

export default class FundVideoProxy {
  digitalDesignContent: ContentProviderEndpoint;
  fundVideoSubject: ReplaySubject<FundVideo[]>;
  fundVideoWasCalled: boolean;

  constructor(digitalDesignContent: ContentProviderEndpoint) {
    this.digitalDesignContent = digitalDesignContent;
    this.fundVideoSubject = new ReplaySubject<FundVideo[]>();
    this.fundVideoWasCalled = false;
  }

  getFundVideoList(): Observable<FundVideo[]> {
    if (!this.fundVideoWasCalled) {
      this.fundVideoWasCalled = true;
      this.digitalDesignContent
        .items<FundVideo>()
        .type('fund_video')
        .orderByDescending('elements.baseDatepublished')
        .toObservable()
        .pipe(map((x) => x.items))
        .subscribe({
          next: (videos) => this.fundVideoSubject.next(videos),
          error: (err) => {
            console.error('Error in getFundVideoList:', err);
            this.fundVideoSubject.error(err);
          },
        });
    }
    return this.fundVideoSubject;
  }
}
